import store from '@/store'

export default class GitHubApi {
  static async saveGitHubToken (code) {
    return await store.dispatch('github/saveGitHubToken', { code })
  }

  static async removeGitHubToken (username) {
    return await store.dispatch('github/removeGitHubToken', { username })
  }

  static async listGitHubRepos (login) {
    return await store.dispatch('github/listGitHubRepos', { login })
  }

  static async listRepoBranches (login, owner, repo) {
    return await store.dispatch('github/listGitHubRepoBranches', { login, owner, repo })
  }

  static async createGitHubRepo (login, repo, description, isPrivate) {
    return await store.dispatch('github/createGitHubRepo', { login, repo, description, isPrivate })
  }

  static async initGitHubRepo (login, owner, repo, branch = 'main', filePath, content, message) {
    return await store.dispatch('github/initGitHubRepo', { login, owner, repo, branch, filePath, content, message })
  }

  static async listGitHubRepoFiles (login, owner, repo, folder = null, branch = 'main') {
    return await store.dispatch('github/listGitHubRepoFiles', { login, owner, repo, folder, branch })
  }

  static async fetchGitHubRepoFileContent (login, owner, repo, branch, files) {
    return await store.dispatch('github/fetchGitHubRepoFileContent', { login, owner, repo, branch, files })
  }

  static async commitGitHubRepoFiles (login, owner, repo, branch = 'main', files, message) {
    return await store.dispatch('github/commitGitHubRepoFiles', { login, owner, repo, branch, files, message })
  }

  static async deleteGitHubRepo (login, owner, repo) {
    return await store.dispatch('github/deleteGitHubRepo', { login, owner, repo })
  }
}
